import React, { useCallback, useContext, useEffect, useState } from 'react'
import { MemoryRouter, Route, Switch, useHistory, useParams } from 'react-router'
import { AppContext } from '../../Context'
import DeclarationDetail from './DeclarationDetail'
import DeclarationForm from './DeclarationForm'
import { getRecord } from '../../services/record-services'

export const DeclarationContext = React.createContext({})

export default function DeclarationPage({ ...props }) {
  const { tokenId, employee } = useContext(AppContext)
  const [record, setRecord] = useState(null)

  const { id } = useParams()
  const history = useHistory()

  const fetchRecord = useCallback(async () => {
    if(employee) {
      const result = await getRecord(id, recordData)
      if (result.data.getRecord && result.data.getRecord.length > 0) {
        const r = result.data.getRecord[0]
        setRecord(r)
      } else {
        history.push('/error/404')
      }
    }
  }, [id, history])

  useEffect(() => {
    if (id && tokenId) {
      fetchRecord()
    }
  }, [id, tokenId, fetchRecord])


  const myContext = {
    recordId: id,
    record,
    setRecord,
    parentHistory: history
  }
  return <MemoryRouter>
    <DeclarationContext.Provider value={ myContext }>
      <Switch>
        <Route path='/' exact={true} component={ DeclarationDetail }/>
        <Route path={ '/declare' } component={ DeclarationForm }/>
      </Switch>
    </DeclarationContext.Provider>
  </MemoryRouter>
}

const recordData = `
  _id
  reference
  status
  partnerAnnualNetIncome
  singleParent
  babysittingMode
  hoursType
  startDate
  validateDate
  archivedDate
  child {
    id
    ageCategory
    expired
    dateOfBirth
    firstName
    lastName
  }
  employee {
    firstName
    lastName
  }
`

export const declarationData = `
  _id
  basageId
  recordId
  ratpId
  status
  declareDate
  period
  hours
  attachments {
    category
    key
    name
    size
    mimetype
  }
`
